<template>
  <div class="section order-detail">
    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      label-position="left"
      :disabled="isLook"
      :show-message="false"
    >
      <el-collapse :value="collapse">
        <el-collapse-item
          title="订单信息"
          :name="1"
        >
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                label="订单号"
                required
                prop="poNo"
              >
                <el-input v-model="form.poNo" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="起运港"
                prop="loadingPortCode"
              >
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_Seaport"
                  filterable
                  :default-value="form.loadingPortCode"
                  style="width:100%;"
                  @parentCallBack="p=>form.loadingPortCode=p.value"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="目的港"
                prop="destinationPortCode"
              >
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_Seaport"
                  filterable
                  :default-value="form.destinationPortCode"
                  style="width:100%"
                  @parentCallBack="p=>form.destinationPortCode=p.value"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                label="客户"
                required
                prop="customerId"
              >
                <cargo-advance-select
                  init-notify
                  :select-type="selectTypeNames.basic_data_Company"
                  filterable
                  :default-value="form.customerId||''"
                  tag-name="chineseName"
                  style="width:100%;"
                  :method-params="{customer:true}"
                  @parentCallBack="customerChange"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="供应商"
                prop="supplierId"
              >
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_Company"
                  filterable
                  :default-value="form.supplierId||''"
                  tag-name="chineseName"
                  style="width:100%;"
                  :method-params="{tradersSign:true}"
                  @parentCallBack="p=>form.supplierId=p.value"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="PO创建时间"
                prop="poCreationDate"
              >
                <el-date-picker
                  v-model="form.poCreationDate"
                  type="date"
                  clearable
                  style="width:100%;"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item :label="$t('Order.Shipper')">
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{shipper:true,active:true}"
                  filterable
                  :default-value="form.shipper||''"
                  style="width:100%;"
                  @parentCallBack="p=>{form.shipper=p.value}"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('Order.RelatedParty')">
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{factorySign:true,active:true}"
                  filterable
                  :default-value="form.relatedParty||''"
                  style="width:100%;"
                  @parentCallBack="p=>{form.relatedParty=p.value}"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('Order.EntrustingDate')">
                <el-date-picker v-model="form.entrustingDate" type="date" clearable style="width:100%;" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item :label="$t('Order.Consignee')">
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{consignee:true,active:true}"
                  filterable
                  :default-value="form.consignee||''"
                  style="width:100%;"
                  @parentCallBack="p=>{form.consignee=p.value}"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="8">
              <el-form-item
                label="订单渠道"
                prop="source"
              >
                <el-input v-model="form.source" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item
                label="收货地址"
                prop="deliveryAddress"
              >
                <el-input v-model="form.deliveryAddress" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item
                label="备注"
                prop="remarks"
              >
                <el-input
                  v-model="form.remarks"
                  type="textarea"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item
          title="箱货信息"
          :name="4"
        >
          <booking-sea-eq-data-grid
            ref="orderSeaEqDataGrid"
            :value="form.seaEQ"
            container-load-type="FCL"
            :is-edit="!isLook"
            :job="form"
          />
          <el-form-item
            label="注意事项"
            style="width: 60%;"
          >
            <el-input
              v-model="form.matters"
              style="min-height: 80px"
              type="textarea"
            />
          </el-form-item>
        </el-collapse-item>
        <el-collapse-item
          title="货物跟踪"
          :name="2"
        >
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                label="要求货好时间"
                prop="requestedIncomeDate"
              >
                <el-date-picker
                  v-model="form.requestedIncomeDate"
                  type="date"
                  clearable
                  style="width:100%;"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="预计货好时间"
                prop="estimatedIncomeDate"
              >
                <el-date-picker
                  v-model="form.estimatedIncomeDate"
                  disabled
                  type="date"
                  clearable
                  style="width:100%;"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="进仓状态"
                prop="warehouseInState"
              >
                <el-select
                  v-model="form.warehouseInState"
                  disabled
                >
                  <el-option
                    :value="-1"
                    label="进仓异常"
                  />
                  <el-option
                    :value="0"
                    label="未进仓"
                  />
                  <el-option
                    :value="1"
                    label="部分进仓"
                  />
                  <el-option
                    :value="2"
                    label="全部进仓"
                  />
                  <el-option
                    :value="3"
                    label="None-无"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item
                label="延迟交货原因"
                prop="incomeDelayReason"
              >
                <el-input
                  v-model="form.incomeDelayReason"
                  type="textarea"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="装箱完成日期"
                prop="loadingDate"
              >
                <el-date-picker
                  v-model="form.loadingDate"
                  type="date"
                  clearable
                  style="width:100%;"
                  disabled
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                label="预计离港时间"
                prop="etd"
              >
                <el-date-picker
                  v-model="form.etd"
                  type="date"
                  clearable
                  style="width:100%;"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="要求送达时间"
                prop="requestedDeliveryDate"
              >
                <el-date-picker
                  v-model="form.requestedDeliveryDate"
                  type="date"
                  clearable
                  style="width:100%;"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="预计送达时间"
                prop="estimatedDeliveryDate"
              >
                <el-date-picker
                  v-model="form.estimatedDeliveryDate"
                  type="date"
                  clearable
                  style="width:100%;"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item
                label="离港延误原因"
                prop="departureDelayReason"
              >
                <el-input
                  v-model="form.departureDelayReason"
                  type="textarea"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item
          title="商品信息"
          :name="3"
        >
          <goods-info
            ref="goodsInfo"
            :order-uuid="orderUuid"
            :po-no="orderInfo?orderInfo.poNo:''"
            :po-state="orderInfo?orderInfo.state:null"
            :order-edit-type="oprationType"
            @goodsSave="goodsSave"
          />
        </el-collapse-item>
        <el-collapse-item
          title="包装信息"
          :name="4"
        >
          <package-info
            ref="packageInfo"
            :order-uuid="orderUuid"
            :po-no="orderInfo?orderInfo.poNo:''"
            :po-state="orderInfo?orderInfo.state:null"
            :customer-id="orderInfo?orderInfo.customerId:null"
            :order-edit-type="oprationType"
          />
        </el-collapse-item>
        <el-collapse-item
          title="操作信息"
          :name="5"
        >
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                label="销售公司"
                required
                prop="salesOffice"
              >
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_Office"
                  init-notify
                  filterable
                  :default-value="form.salesOffice"
                  tag-name="chineseName"
                  style="width:100%"
                  @parentCallBack="salesOfficeChange"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="销售部门"
                required
                prop="salesDept"
              >
                <cargo-department-select-by-office-id
                  :office-id="Number(form.salesOffice)"
                  :department-id="Number(form.salesDept)"
                  @change="salesDeptChange"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="销售"
                prop="salesId"
              >
                <cargo-advance-select
                  :url="URL.order.getUsersByOfficeAndDept"
                  :cache="false"
                  filterable
                  :default-value="form.salesId||''"
                  :method-params="{officeId:form.salesOffice?form.salesOffice:$store.getters.currentOfficeId,deptId:form.salesDept,category:'role',shape:'sales'}"
                  tag-name="chineseName"
                  tag-value="userId"
                  style="width:100%;"
                  @parentCallBack="salesChange"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                label="操作公司"
                required
                prop="opOffice"
              >
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_Office"
                  filterable
                  :default-value="form.opOffice"
                  tag-name="chineseName"
                  style="width:100%"
                  @parentCallBack="opOfficeChange"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="操作部门"
                required
                prop="opDepartment"
              >
                <cargo-department-select-by-office-id
                  :office-id="Number(form.opOffice)"
                  :department-id="Number(form.opDepartment)"
                  @change="opDeptChange"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="操作"
                prop="opId"
              >
                <cargo-advance-select
                  :url="URL.order.getUsersByOfficeAndDept"
                  :cache="false"
                  filterable
                  :default-value="form.opId||''"
                  tag-name="chineseName"
                  tag-value="userId"
                  style="width:100%;"
                  :method-params="{officeId:form.opOffice?form.opOffice:$store.getters.currentOfficeId,deptId:form.opDepartment,category:'role',shape:'op'}"
                  @parentCallBack="opChange"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                label="操作要求"
                prop="operationRequirement"
              >
                <el-input
                  :value="form.operationRequirement"
                  :placeholder="isLook ? '': '双击添加操作要求'"
                  type="textarea"
                  :rows="2"
                  @dblclick.native="selectOperationReqDialog.visible=true"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
      </el-collapse>
    </el-form>
    <!-- 操作要求弹窗 -->
    <select-operation-req-dialog
      :visible.sync="selectOperationReqDialog.visible"
      lob="SE"
      :value="form.operationRequirement"
      @callback="val=>form.operationRequirement=val"
    />
  </div>
</template>
<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import URL from '@/api/urlTranslator'
import goodsInfo from './goodsInfo'
import packageInfo from './packageInfo'
import cargoDepartmentSelectByOfficeId from '@/components/Cargo/Common/cargoDepartmentSelectByOfficeId'
import selectOperationReqDialog from '@/components/Cargo/Job/selectOperationReqDialog'
import { queryPoInfo, getUsersByUserId } from '@/api/OMS/order'
import { getLoading } from '@/utils/utilBaseElement'
import BookingSeaEqDataGrid from '@/components/Cargo/Job/bookingSeaEqDataGrid'
import StrUtils from '@/utils/StrUtils'
import DateUtils from '@/utils/dateUtils'
export default {
  name: 'BaseInfo',
  components: {
    BookingSeaEqDataGrid,
    cargoAdvanceSelect,
    goodsInfo,
    packageInfo,
    cargoDepartmentSelectByOfficeId,
    selectOperationReqDialog
  },
  props: {
    orderUuid: { type: String, default: () => '' },
    oprationType: { type: Number, default: () => 1 }
  },
  data() {
    return {
      form: {
        poNo: '',
        loadingPortCode: '',
        destinationPortCode: '',
        customerId: '',
        supplierId: '',
        poCreationDate: '',
        deliveryAddress: '',
        source: '',
        remarks: '',
        requestedIncomeDate: '',
        estimatedIncomeDate: '',
        loadingDate: '',
        incomeState: '',
        incomeDelayReason: '',
        etd: '',
        requestedDeliveryDate: '',
        estimatedDeliveryDate: '',
        departureDelayReason: '',
        salesOffice: '',
        salesDept: '',
        salesId: '',
        opOffice: '',
        opDepartment: '',
        opId: '',
        operationRequirement: '',
        warehouseInState: '',
        version: '',
        containerDesc: '',
        seaEQ: [],
        matters: '',
        relatedParty: '',
        shipper: '',
        consignee: '',
        entrustingDate: DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
      },
      container: {},
      collapse: [0, 1, 2, 3, 4, 5],
      selectTypeNames: TYPE_NAMES,
      URL,
      selectOperationReqDialog: {
        visible: false,
        value: ''
      },
      orderInfo: null
    }
  },
  computed: {
    isLook() {
      return this.oprationType !== 2 && this.oprationType !== 3
    },
    seaEQ() {
      return this.form.seaEQ
    }
  },
  watch: {
    orderUuid(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.handleGetOrderInfo()
      } else {
        this.$refs.form.resetFields()
        this.orderInfo = null
      }
    },
    oprationType(val) {
      if (val !== 2) {
        this.handleGetOrderInfo()
      } else {
        this.form.version = null
      }
    },
    seaEQ(val) {
      if (val && val.length > 0) {
        this.form.warehouseInState = 3
      }
    }
  },
  methods: {
    handleGetOrderInfo() {
      this.loading = getLoading()
      const { orderUuid } = this
      queryPoInfo({ uuid: orderUuid })
        .then((res) => {
          this.orderInfo = res.data
          Object.keys(this.form).forEach((key) => {
            if (key in this.form) {
              this.form[key] = res.data[key]
            }
          })
          this.getSeqEQs()
          this.loading.close()
        })
        .catch(() => {
          this.loading.close()
        })
    },
    salesOfficeChange(office) {
      console.log('init', office)
      this.form.salesId = null
      this.form.salesOffice = office.value
      this.form.salesDept = null
    },
    salesDeptChange(dept) {
      console.log('dept', dept)
      this.form.salesId = null
      this.form.salesDept = dept.value
    },
    salesChange(item) {
      this.form.salesId = item.value
      getUsersByUserId({
        userId: item.value,
        officeId: this.form.salesOffice || this.$store.getters.currentOfficeId,
        deptId: this.form.salesDept
      }).then((res) => {
        if (!this.form.salesOffice) {
          this.form.salesOffice = res.data ? res.data.officeId : 0
        }
        if (!this.form.salesDept) {
          this.form.salesDept = res.data ? res.data.departmentId : 0
        }
      })
    },
    opOfficeChange(office) {
      this.form.opId = null
      this.form.opOffice = office.value
      this.form.opDepartment = null
    },
    opDeptChange(dept) {
      this.form.opId = null
      this.form.opDepartment = dept.value
    },
    opChange(item) {
      this.form.opId = item.value
      getUsersByUserId({
        userId: item.value,
        officeId: this.form.opOffice || this.$store.getters.currentOfficeId,
        deptId: this.form.opDepartment
      }).then((res) => {
        if (!this.form.opDepartment) {
          this.form.opDepartment = res.data ? res.data.departmentId : 0
        }
        if (!this.form.opOffice) {
          this.form.opOffice = res.data ? res.data.officeId : 0
        }
      })
    },
    customerChange(item) {
      const goodsList = this.$refs.goodsInfo.rowData
      const preVal = this.form.customerId
      this.form.customerId = item.value
      if (goodsList.length > 0) {
        const h = this.$createElement
        const content = h('div', { style: 'color:red' }, [
          h('p', null, '订单中已关联此客户商品信息，不可修改客户'),
          h('p', null, '如需修改，请先移除商品信息')
        ])
        this.$confirm(content, '取消订单', {
          type: 'warning'
        }).then(() => {
          this.form.customerId = preVal
        })
      }
    },
    getSeqEQs() {
      const { form } = this
      if (StrUtils.isEmpty(form.containerDesc)) {
        return []
      }
      const list = form.containerDesc.split('\n')
      const newSeaList = []
      for (const seaArr of list) {
        const sea = seaArr.split(' ')
        const newSeq = {
          eqQuantity: sea[0].trim(),
          eqType: sea[3].trim(),
          eqSize: sea[2].trim(),
          soc: (sea.length > 4 && sea[4] === '1')
        }
        newSeaList.push(newSeq)
      }
      form.seaEQ = newSeaList
    },
    goodsSave() {
      if (this.$refs.packageInfo) {
        this.$refs.packageInfo.handleQuery(1)
      }
    }
  }
}
</script>
<style lang="scss">
.order-detail {
  .el-collapse {
    &-item {
      &__header {
        padding: 0 15px;
        border-bottom: none;
        color: #4283ff;
        font-weight: bold;
        background-color: #fff;
      }
      &__wrap {
        padding: 15px;
        border-bottom: none;
        background-color: #f0f3f8!important;
      }
      &__arrow {
        color: #303133;
      }
    }
  }
}
</style>
